__turbopack_context__.v({
  "skipLink": "SkipLink-module__8rcVEW__skipLink",
});
